var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import useDeleteAction from './useDeleteAction';
/**
 * @export
 * Declarative component wrapper for delete actions
 *
 * Provides a render-prop pattern for triggering delete actions with
 * automatic dependency checking and confirmation dialogs.
 *
 * @example Basic usage with button
 * ```tsx
 * <DeleteAction
 *   model="Location.Location"
 *   objectKey={locationKey}
 *   canHide={true}
 *   onSuccess={(action) => {
 *     if (action === 'delete') {
 *       navigate('/locations');
 *     }
 *   }}
 * >
 *   {(handleDelete) => (
 *     <Button onClick={handleDelete}>Delete Location</Button>
 *   )}
 * </DeleteAction>
 * ```
 *
 * @example With custom title and messages
 * ```tsx
 * <DeleteAction
 *   model="User.User"
 *   objectKey={userId}
 *   deleteTitle="Delete User"
 *   deleteMessage="Are you sure you want to delete this user?"
 *   onSuccess={() => refetch()}
 * >
 *   {(handleDelete) => (
 *     <IconButton icon="fas trash" onClick={handleDelete} />
 *   )}
 * </DeleteAction>
 * ```
 *
 * @example In an action list
 * ```tsx
 * <ActionList>
 *   <DeleteAction
 *     model="Equipment.Equipment"
 *     objectKey={equipmentKey}
 *     canHide={true}
 *     onSuccess={() => reloadTable()}
 *   >
 *     {(handleDelete) => (
 *       <ActionItem
 *         icon="fas trash"
 *         label="Delete"
 *         onClick={handleDelete}
 *       />
 *     )}
 *   </DeleteAction>
 * </ActionList>
 * ```
 *
 * @category Buttons
 */
const DeleteAction = (props) => {
    const { model, objectKey, children } = props, deleteParams = __rest(props, ["model", "objectKey", "children"]);
    const deleteAction = useDeleteAction();
    const handleDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        yield deleteAction.delete(Object.assign({ model, key: objectKey }, deleteParams));
    });
    return (_jsx(_Fragment, { children: children(handleDelete) }));
};
export default DeleteAction;
